// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_XkJ","cls2":"common-cls2_rlc common-cls1_XkJ"};